import PropTypes from "prop-types";

import { strCode } from "../../consts";
import { t } from "../../services";

import { FlexContainers, Paragraph2 } from "../../components";
import { TableInfoWrapper } from "./styled";

const TableInfo = ({
  searchedText,
  searchInfo,
  searchCheckInfo,
  noDataInfo,
  disableScroll,
  modalTable
}) => {
  return (
    <TableInfoWrapper
      disableScroll={disableScroll}
      Container={FlexContainers.FlexColumnCenter}
      modalTable={modalTable}>
      {searchedText && searchInfo ? (
        <>
          <Paragraph2>{searchInfo}</Paragraph2>
          {searchCheckInfo && <Paragraph2>{searchCheckInfo}</Paragraph2>}
        </>
      ) : (
        <Paragraph2>{noDataInfo ?? t(strCode.NO_DATA)}</Paragraph2>
      )}
    </TableInfoWrapper>
  );
};

TableInfo.propTypes = {
  searchedText: PropTypes.string,
  searchInfo: PropTypes.string,
  searchCheckInfo: PropTypes.string,
  noDataInfo: PropTypes.string,
  disableScroll: PropTypes.bool,
  modalTable: PropTypes.bool
};

export default TableInfo;
